import * as React from "react";
import { Flex } from "@chakra-ui/react";
import {
  GeneralAssessment,
  DentalCharting,
  TotalTimer,
  Photos,
  Reports,
  Treatments
} from "./components";

const DentalTab: React.FC = () => (
  <Flex mt={6} direction="column" gap={6}>
    <GeneralAssessment />
    <DentalCharting />
    <Treatments />
    <Photos />
    <Reports />
    <TotalTimer />
  </Flex>
);

export default DentalTab;
